// Página de informação do produto.
// O produto é identificado pelo parâmetro ?prd=<id> da URL (?sku=<sku> é opcional e define a cor exibida).
const API_URL = 'https://api.dorel.com.br/v1/catalog/product_assistances';
const REGISTRY_PATH = '/registro';
const YOUTUBE_OEMBED = 'https://www.youtube.com/oembed';

const urlParams = new URLSearchParams(window.location.search);
const prd = urlParams.get('prd');
const sku = urlParams.get('sku');

const productInfo = document.getElementById('productInfo');
const infoLinks = document.getElementById('info-links');
const categoryName = document.querySelector('.category-name');
const productTitle = document.querySelector('#productInfo h1');
const productColorName = document.querySelector('.product-color');
const manualLink = document.getElementById('manual-link');
const videoContainer = document.querySelector('.video-container');
const videoItem = document.getElementById('video-item');
const manualItem = document.getElementById('manual-item');
const videoLink = document.getElementById('video-link');
const modalGeneric = document.getElementById('modalGeneric');
const modalTitle = document.getElementById('modalGenericTitle');
const modalContent = document.getElementById('modalGenericContent');
const registryLinks = document.querySelectorAll('[data-registry-link]');
const productSkeleton = document.getElementById('productSkeleton');
const productMessage = document.getElementById('productMessage');
const warranty = document.getElementById('warranty');
const warrantyBadge = document.getElementById('warrantyBadge');
const warrantyPeriod = document.getElementById('warrantyPeriod');
const warrantyNote = document.getElementById('warrantyNote');

async function getData(apiUrl) {
  const response = await fetch(apiUrl);
  if (!response.ok) {
    throw new Error(`Não foi possível carregar o catálogo (${response.status})`);
  }
  return response.json();
}

// A API filtra no servidor, e o parametro certo e `product_id` — `id` e `prd` sao
// ignorados e devolvem o catalogo inteiro. Como o QR sempre carrega o id, este e o
// caminho normal da pagina:
//
//   ?product_id=  ->    2 KB,   38 ms, produto completo com todas as cores
//   ?sku=         ->    1 KB,   52 ms, mas so com o item daquele sku
//   sem filtro    ->  926 KB, 1350 ms, 1096 produtos para exibir um
//
// A resposta do product_id e byte-identica ao registro do catalogo completo, entao
// nao se perde nada. O catalogo inteiro fica so como plano B.
async function carregarProduto(apiUrl) {
  if (prd) {
    const achado = await buscarFiltrado(`${apiUrl}?product_id=${encodeURIComponent(prd)}`);
    if (achado) return achado;
  }

  // sem prd, o sku ainda resolve — com a ressalva de vir so aquela cor
  if (sku) {
    const achado = await buscarFiltrado(`${apiUrl}?sku=${encodeURIComponent(sku)}`);
    if (achado) return achado;
  }

  return findProduct(await getData(apiUrl), prd, sku);
}

// Filtro do servidor falha de duas formas: erro de rede/HTTP, ou 200 com lista vazia
// quando o identificador nao existe. As duas caem no catalogo completo.
async function buscarFiltrado(url) {
  try {
    return findProduct(await getData(url), prd, sku);
  } catch (error) {
    console.warn('[info] filtro no servidor indisponível, caindo no catálogo completo:', error);
    return null;
  }
}

// Um estado por vez: esqueleto enquanto busca, mensagem quando nao da certo,
// banner quando da. Antes so o ultimo existia e os outros dois eram tela vazia.
function mostrarEstado(qual) {
  if (productSkeleton) productSkeleton.classList.toggle('d-none', qual !== 'carregando');
  if (productMessage) productMessage.classList.toggle('d-none', qual !== 'mensagem');
  if (productInfo) productInfo.classList.toggle('d-none', qual !== 'produto');
}

function mostrarMensagem(titulo, texto, acaoHtml) {
  if (!productMessage) return;
  productMessage.querySelector('.product-message__titulo').textContent = titulo;
  productMessage.querySelector('.product-message__texto').textContent = texto;
  productMessage.querySelector('.product-message__acao').innerHTML = acaoHtml || '';
  mostrarEstado('mensagem');
}

async function inicializar(apiUrl) {
  setRegistryLink(prd);

  // Sem identificacao do produto nao ha o que buscar: dizer isso e melhor
  // do que deixar o topo da pagina vazio sem explicacao.
  if (!prd && !sku) {
    mostrarMensagem(
      'Nenhum produto selecionado',
      'Abra esta página pelo link do seu produto ou faça o registro para encontrá-lo.',
      `<a class="product-message__link" href="${REGISTRY_PATH}">Ir para o registro</a>`
    );
    return;
  }

  mostrarEstado('carregando');

  try {
    const product = await carregarProduto(apiUrl);

    if (!product) {
      mostrarMensagem(
        'Produto não encontrado',
        'Não localizamos este produto no catálogo. Confira o link ou procure pelo registro.',
        `<a class="product-message__link" href="${REGISTRY_PATH}">Ir para o registro</a>`
      );
      return;
    }

    await setProductInfo(product);
  } catch (error) {
    console.error('Erro ao carregar os dados do produto:', error);
    mostrarMensagem(
      'Não foi possível carregar as informações',
      'A consulta ao catálogo falhou. Verifique sua conexão e tente novamente.',
      '<button type="button" class="product-message__link" onclick="location.reload()">Tentar de novo</button>'
    );
  }
}

// Produto pelo parâmetro prd (id); sem resultado, tenta pelo sku de um dos itens
function findProduct(data, id, cod_sku) {
  if (!Array.isArray(data)) return null;

  if (id) {
    const byId = data.find((pd) => pd.id === id);
    if (byId) return byId;
  }
  if (cod_sku) {
    return data.find((pd) => (pd.items || []).some((item) => item.sku === cod_sku)) || null;
  }
  return null;
}

// Item (cor) do produto: o do sku informado ou, na falta dele, o primeiro com imagem
function findItem(product, cod_sku) {
  const items = product.items || [];

  if (cod_sku) {
    const bySku = items.find((item) => item.sku === cod_sku);
    if (bySku) return bySku;
  }
  return items.find((item) => item.image_url) || items[0] || null;
}

async function setProductInfo(product) {
  const item = findItem(product, sku);

  categoryName.textContent = product.category || '';
  productTitle.textContent = product.name || '';
  // A cor só é exibida quando o sku foi informado, já que o produto tem várias
  productColorName.textContent = sku && item ? item.color_name || '' : '';

  setMetaTags(product, item);
  setWarranty(product);
  setManual(product);

  infoLinks.classList.remove('d-none');
  mostrarEstado('produto');

  await setMedia(product, item);
}

// Title, description e imagem de compartilhamento por produto. Antes a pagina inteira
// usava o titulo padrao ("Informacoes do produto") e a descricao generica da loja, entao
// todo produto competia com o mesmo snippet na busca.
//
// Ressalva: og:* trocado por JS e lido pelo Google, que renderiza, mas NAO pelos
// raspadores de WhatsApp, Facebook e Twitter, que so leem o HTML servido. Para o
// compartilhamento pegar a foto certa, o dado precisaria vir do servidor.
function setMetaTags(product, item) {
  // "Informacoes sobre banheira Drippy Retratil com Suporte" — a categoria entra
  // em minuscula porque funciona como substantivo comum na frase; o nome do
  // produto vem como o catalogo registra.
  const categoria = (product.category || '').toLowerCase();
  const nome = [categoria, product.name].filter(Boolean).join(' ');

  if (nome) {
    const titulo = `Informações sobre ${nome}`;
    document.title = titulo;
    definirMeta('ogTitle', titulo);
    definirMeta('twTitle', titulo);
  }

  // A descricao NAO e reescrita aqui: ela usa o nome da loja, nao dado do produto,
  // entao ja sai pronta do servidor — e assim tambem vale para o raspador de link,
  // que nao roda JS. Reescreve-la no cliente so introduziria divergencia.

  if (item && item.image_url) {
    definirMeta('ogImage', item.image_url, 'property', 'og:image');
    definirMeta('ogImageSecure', item.image_url, 'property', 'og:image:secure_url');
    definirMeta('ogImageAlt', nome || product.name || '', 'property', 'og:image:alt');
  }
}

// A tag pode nao vir do servidor (og:image so e emitida quando ha imagem raster),
// entao aqui ela e criada se faltar — o atributo diz se e `property` ou `name`.
function definirMeta(id, valor, atributo, chave) {
  let el = document.getElementById(id);

  if (!el) {
    if (!atributo || !chave) return;
    el = document.createElement('meta');
    el.id = id;
    el.setAttribute(atributo, chave);
    document.head.appendChild(el);
  }

  el.setAttribute('content', valor);
}

// Regras de garantia iguais as do getWarrantyFlags() da pagina de Registro:
// '+' indica cobertura alem da padrao, '*' indica que ela depende do cadastro do selo.
function warrantyFlags(product) {
  const texto = product.warranty || '';
  const estendida = texto.includes('+');
  const exigeSelo = texto.includes('*');

  return { estendida, exigeSelo, precisaSelo: product.guarantee_seal === true && estendida && exigeSelo };
}

// A garantia e o motivo pelo qual a pessoa chega nesta pagina, e nao era exibida.
// Mesmos tres elementos da pagina de Registro: a tag, o periodo cru vindo da API
// e a nota que so aparece quando ha cobertura estendida.
// Verde e ambar sao estados semanticos, nao cor de marca — iguais em toda loja.
const ICONE_OK =
  '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" ' +
  'd="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path></svg>';
const ICONE_ALERTA =
  '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" ' +
  'd="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path></svg>';

function setWarranty(product) {
  if (!warranty || !product.warranty) return;

  const { estendida, precisaSelo } = warrantyFlags(product);

  warrantyBadge.className = `warranty-badge warranty-badge--${estendida ? 'estendida' : 'padrao'}`;
  warrantyBadge.innerHTML =
    (estendida ? ICONE_OK : ICONE_ALERTA) +
    `<span>${estendida ? 'Garantia estendida aplicável' : 'Garantia padrão'}</span>`;

  // O periodo vem pronto da API: "24 meses (Garantia Padrão) + 36 meses (Garantia Estendida*)"
  warrantyPeriod.textContent = product.warranty;

  if (precisaSelo) {
    warrantyNote.textContent = '*Garantia estendida aplicável mediante registro do produto';
    warrantyNote.classList.remove('d-none');
  }

  warranty.classList.remove('d-none');
}

// O catálogo às vezes traz o código com query colada ("abc?si=...") ou a URL inteira; só o id serve
function youtubeId(code) {
  const match = String(code || '')
    .trim()
    .match(/(?:youtu\.be\/|v[=/]|embed\/)?([A-Za-z0-9_-]{11})(?:[?&#].*)?$/);

  return match ? match[1] : '';
}

// Vídeo privado, removido ou sem permissão de embed responde diferente de 200 no oEmbed.
// Sem essa checagem o player entra na página exibindo "vídeo indisponível" no lugar do produto.
// A mesma resposta traz o título, que reaproveitamos como rótulo quando há mais de um vídeo.
async function videoInfo(videoId) {
  const alvo = `https://www.youtube.com/watch?v=${videoId}`;

  try {
    const response = await fetch(`${YOUTUBE_OEMBED}?format=json&url=${encodeURIComponent(alvo)}`);
    if (!response.ok) return null;
    return await response.json();
  } catch (error) {
    // rede fora ou bloqueio: melhor não oferecer o vídeo do que arriscar o player quebrado
    return null;
  }
}

// Hoje o catálogo devolve `youtube_code` como string única, mas o campo já está previsto
// para virar lista. Aceitamos array, string separada por , ; | ou quebra de linha, e um
// futuro campo `videos` — sem depender de qual formato chegar primeiro.
function videoCodes(product) {
  const bruto = product.videos != null ? product.videos : product.youtube_code;
  const lista = Array.isArray(bruto) ? bruto : String(bruto || '').split(/[,;|\s]+/);

  return [...new Set(lista.map(youtubeId).filter(Boolean))];
}

// Havendo vídeo, ele é o conteúdo do banner. A foto entra só quando não há nenhum,
// ou quando os códigos existem mas nenhum passa na checagem do oEmbed.
// A area de midia e pintada UMA vez. videoCodes() e sincrono, entao da para saber
// antes de qualquer chamada de rede se o player vai assumir o lugar da foto — assim
// o usuario nao ve a imagem entrar e ser trocada pelo YouTube meio segundo depois.
async function setMedia(product, item) {
  // campos do catálogo chegam como null com alguma frequência, então nada de concatenar direto
  // Cru de proposito: escapar aqui causava escape duplo no catalogo do modal e texto
  // com entidade visivel no atributo title do player. Escapa-se no ponto de insercao.
  const title = [product.name, product.brand_name].filter(Boolean).join(' | ');
  const ids = videoCodes(product);
  // Havendo video, ele e o conteudo do banner — a foto so entra quando nao ha nenhum.
  const playerAssume = ids.length > 0;

  if (playerAssume) {
    // mesma caixa 16/9 que o player vai ocupar: a troca nao mexe um pixel
    videoContainer.innerHTML =
      '<div class="video-inline-wrap"><div class="sk ratio ratio-16x9"></div></div>';
  } else {
    pintarImagem(item, title);
  }

  const videos = await resolverVideos(ids, title);

  if (videos.length) {
    pintarPlayer(videos[0]);
  } else if (playerAssume) {
    // os codigos nao passaram na checagem do oEmbed: a foto volta a ser o conteudo
    pintarImagem(item, title);
  }

  configurarPilulaVideo(videos);
}

function pintarImagem(item, title) {
  if (!item || !item.image_url) {
    videoContainer.innerHTML = '';
    return;
  }

  // A foto e o elemento principal do banner: carrega com prioridade e sem
  // bloquear a decodificacao. O alt descreve o produto, nao "imagem".
  videoContainer.innerHTML =
    `<div><img src="${escapeHtml(item.image_url)}" class="img-thumbnail" alt="${escapeHtml(title)}"` +
    ` loading="eager" fetchpriority="high" decoding="async"></div>`;
}

function pintarPlayer(video) {
  // O <div> externo recebe a regra de flex de .video-container > div; o .ratio
  // do Bootstrap fica isolado dentro dele para o truque de proporcao nao quebrar.
  videoContainer.innerHTML =
    '<div class="video-inline-wrap"><div class="video-inline ratio ratio-16x9">' +
    '<div id="playerBanner"></div></div></div>';
  criarPlayer('playerBanner', video.id, video.titulo, false);
}

// Só entra na lista o que o oEmbed confirmar que toca. A mesma resposta traz
// titulo e miniatura, que o catalogo do modal reaproveita.
async function resolverVideos(ids, title) {
  const videos = [];

  for (const id of ids) {
    const info = await videoInfo(id);
    if (info) {
      videos.push({
        id,
        titulo: info.title || title,
        thumb: info.thumbnail_url || `https://img.youtube.com/vi/${id}/mqdefault.jpg`
      });
    }
  }

  return videos;
}

// A pílula só aparece com pelo menos um vídeo válido. O rótulo depende da contagem
// FINAL, pos-oEmbed: "Mais vídeos" so faz sentido se um deles ja estiver no banner.
function configurarPilulaVideo(videos) {
  // Com um video so, ele ja esta tocando no banner e nao ha o que a pilula ofereca.
  if (!videoItem || !videoLink || videos.length < 2) return;

  const rotulo = videoLink.querySelector('.text-link');
  if (rotulo) rotulo.textContent = 'Mais vídeos';

  videoLink.addEventListener('click', (e) => {
    e.preventDefault();
    abrirVideo(videos);
  });

  videoItem.classList.remove('d-none');
}

// No S3 o espaço no nome do arquivo vira "_", mas o catálogo devolve o nome original.
// O acento permanece no arquivo: basta o encodeURI codificar.
function manualUrl(url) {
  const bruto = String(url || '').trim();
  const corte = bruto.lastIndexOf('/');
  if (!bruto || corte < 0) return bruto;

  return encodeURI(bruto.slice(0, corte + 1) + bruto.slice(corte + 1).replace(/\s/g, '_'));
}

// Manuais: a preferência é o objeto manuals; sem ele, o campo manual; sem os dois, o link não aparece.
// Com mais de um (128 produtos no catálogo), a lista vai para o modal em vez de um dropdown na página.
function setManual(product) {
  if (!manualLink || !manualItem) return;

  const manuals = (product.manuals || []).filter((manual) => manual && manual.url);
  const unico = manualUrl(manuals.length ? manuals[0].url : product.manual);

  // sem manual: o botão não entra na linha
  if (!manuals.length && !unico) return;

  // um só: link direto para o PDF, sem modal para um download único
  if (manuals.length <= 1) {
    if (!unico) return;
    manualLink.setAttribute('href', unico);
  } else {
    const html =
      '<ul class="manual-list-modal">' +
      manuals
        .map(
          (manual, index) =>
            `<li><a href="${escapeHtml(manualUrl(manual.url))}" target="_blank" rel="noopener">
              <span>${escapeHtml(manualName(manual, index))}</span>
              ${ICONE_DOWNLOAD}
            </a></li>`
        )
        .join('') +
      '</ul>';

    manualLink.setAttribute('href', 'javascript:void(0);');
    manualLink.setAttribute('role', 'button');
    manualLink.setAttribute('aria-haspopup', 'dialog');
    manualLink.removeAttribute('target');
    manualLink.addEventListener('click', (e) => {
      e.preventDefault();
      abrirModal('Manuais Disponíveis', html);
    });
  }

  manualItem.classList.remove('d-none');
}

// Mesma seta de download dos cartões de manual da página de Registro
const ICONE_DOWNLOAD =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
  '<path stroke-linecap="round" stroke-linejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path></svg>';


// ── Player do YouTube ─────────────────────────────────────────────────────
// O iframe simples nao aceita volume: o YouTube nao expoe parametro de URL para
// isso. Para abrir baixo (10%) e preciso a IFrame Player API, que so responde a
// setVolume em desktop — em iOS e Android o volume e do aparelho e a chamada e
// ignorada pelo sistema. Nesses casos o video simplesmente abre no volume do
// dispositivo, sem erro.
const VOLUME_INICIAL = 10;
let ytPronto = null;
// Duas instancias convivem: a do banner (multi-video) e a do modal. Guardadas por
// id do elemento para o modal poder ser destruido sem derrubar a do banner.
const players = {};

function carregarYT() {
  if (ytPronto) return ytPronto;

  ytPronto = new Promise((resolve) => {
    if (window.YT && window.YT.Player) return resolve(window.YT);

    const anterior = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (typeof anterior === 'function') anterior();
      resolve(window.YT);
    };

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
  });

  return ytPronto;
}

function destruirPlayer(elId) {
  const p = players[elId];
  if (p && typeof p.destroy === 'function') p.destroy();
  delete players[elId];
}

async function criarPlayer(elId, videoId, titulo, autoplay) {
  if (!document.getElementById(elId)) return;

  const YT = await carregarYT();
  // o elemento pode ter saido do DOM enquanto a API carregava
  if (!document.getElementById(elId)) return;

  destruirPlayer(elId);
  players[elId] = new YT.Player(elId, {
    videoId,
    playerVars: { autoplay: autoplay ? 1 : 0, modestbranding: 1, rel: 0, playsinline: 1 },
    events: {
      onReady: (e) => {
        e.target.setVolume(VOLUME_INICIAL);
        if (autoplay) e.target.playVideo();
      }
    }
  });

  const el = document.getElementById(elId);
  if (el) el.setAttribute('title', titulo);
}

// Um video: so o player. Varios: player em cima e um catalogo de miniaturas embaixo,
// incluindo o que esta tocando — trocar de video nao fecha o modal.
function abrirVideo(videos) {
  const catalogo =
    videos.length > 1
      ? '<ul class="video-catalogo">' +
        videos.map((v, i) => cartaoVideo(v, i === 0)).join('') +
        '</ul>'
      : '';

  abrirModal(
    videos.length > 1 ? 'Vídeos do produto' : 'Vídeo do produto',
    `<div class="video-modal">
      <div class="video-modal__player ratio ratio-16x9"><div id="playerModal"></div></div>
      ${catalogo}
    </div>`
  );

  modalContent.classList.add('modal-body--video');
  criarPlayer('playerModal', videos[0].id, videos[0].titulo, true);

  modalContent.querySelectorAll('[data-video]').forEach((cartao) => {
    cartao.addEventListener('click', () => {
      const escolhido = videos.find((v) => v.id === cartao.dataset.video);
      if (!escolhido) return;
      modalContent
        .querySelectorAll('[data-video]')
        .forEach((outro) => outro.removeAttribute('aria-current'));
      cartao.setAttribute('aria-current', 'true');
      criarPlayer('playerModal', escolhido.id, escolhido.titulo, true);
    });
  });
}

function cartaoVideo(v, ativo) {
  return (
    `<li><button type="button" class="video-cartao" data-video="${escapeHtml(v.id)}"` +
    `${ativo ? ' aria-current="true"' : ''}>` +
    `<span class="video-cartao__thumb"><img src="${escapeHtml(v.thumb)}" alt="" loading="lazy" decoding="async">` +
    ICONE_PLAY +
    '</span>' +
    `<span class="video-cartao__titulo">${escapeHtml(v.titulo)}</span>` +
    '</button></li>'
  );
}

const ICONE_PLAY =
  '<svg class="video-cartao__play" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
  '<path d="M8 5v14l11-7z"></path></svg>';

// Modal único, reaproveitado por vídeo e manuais — mesmo desenho do #modalGeneric da página
// de Registro. O conteúdo é limpo ao fechar para o iframe parar de tocar.
function abrirModal(titulo, html) {
  if (!modalGeneric || typeof bootstrap === 'undefined') return;

  modalTitle.textContent = titulo;
  modalContent.classList.remove('modal-body--video');
  modalContent.innerHTML = html;
  bootstrap.Modal.getOrCreateInstance(modalGeneric).show();
}

if (modalGeneric) {
  modalGeneric.addEventListener('hidden.bs.modal', () => {
    destruirPlayer('playerModal');
    modalContent.innerHTML = '';
  });
}

// Nome do arquivo (ex.: "20220825 REV4 Eva STR002 GUIDE.pdf") em um rótulo legível
function manualName(manual, index) {
  const label = String(manual.name || '')
    .replace(/\.pdf$/i, '')
    .split(/[\s_]+/)
    .filter((part) => part && !/^\d{6,8}$/.test(part) && !/^rev\d*$/i.test(part) && !/^guide$/i.test(part))
    .join(' ')
    .trim();

  return label || `Manual ${index + 1}`;
}

// Todos os caminhos para o registro levam o mesmo prd
function setRegistryLink(id) {
  const href = id ? `${REGISTRY_PATH}?prd=${encodeURIComponent(id)}` : REGISTRY_PATH;
  registryLinks.forEach((link) => {
    link.href = href;
  });
}

function escapeHtml(value) {
  return String(value == null ? '' : value).replace(
    /[&<>"']/g,
    (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]
  );
}

inicializar(API_URL);